import { Tag, Tooltip } from 'antd'
import React from 'react'
import styled, { DefaultTheme } from 'styled-components'
import { ForecastTheme } from 'styles/themes'

export interface FormulaToken {
  type:
    | 'sensor'
    | 'operator'
    | 'function'
    | 'number'
    | 'parenthesis'
    | 'placeholder'
  value: string
  displayValue?: string
}

interface FormulaTokenElementProps {
  token: FormulaToken
  index: number
  onRemove: (index: number) => void
  onPlaceholderClick: (token: FormulaToken, index: number) => void
}

const TOKEN_COLORS: Record<FormulaToken['type'], keyof ForecastTheme> = {
  sensor: 'primary',
  operator: 'text1',
  function: 'text1',
  placeholder: 'warning',
  number: 'text1',
  parenthesis: 'text1',
}

const getTokenStyle = (theme: DefaultTheme, type: FormulaToken['type']) => {
  return {
    color: theme.forecast[TOKEN_COLORS[type]],
    background: theme.forecast[TOKEN_COLORS[type]] + '20',
    borderColor: theme.forecast[TOKEN_COLORS[type]],
  }
}

const FormulaChip = styled(Tag)<{ $type: FormulaToken['type'] }>`
  margin: 0;
  cursor: pointer;
  user-select: none;
  ${({ theme, $type }) => getTokenStyle(theme, $type)};
`

export const FormulaTokenElement: React.FC<FormulaTokenElementProps> = ({
  token,
  index,
  onRemove,
  onPlaceholderClick,
}) => {
  const handleClose = () => {
    onRemove(index)
  }

  const handleClick = () => {
    if (token.type === 'placeholder') {
      onPlaceholderClick(token, index)
    }
  }

  const tokenElement = (
    <FormulaChip
      $type={token.type}
      closable
      onClose={handleClose}
      onClick={handleClick}>
      {token.displayValue || token.value}
    </FormulaChip>
  )

  // Wrap placeholder tokens in a tooltip
  if (token.type === 'placeholder') {
    return (
      <Tooltip title='Click to replace with a sensor or value'>
        {tokenElement}
      </Tooltip>
    )
  }

  return tokenElement
}
